<template>
    <el-dialog title="Regroupement de produit" v-loading="loader" :visible.sync="display" width="90%">
        <div class="mb-3">Regroupement de produit</div>
        <el-alert v-if="error" :title="errorMessage" type="error" show-icon>
        </el-alert>
        <el-form class="formGroupProduct" ref="formGroupProduct" :model="form">
            <el-form-item prop="name">
                <el-input placeholder="Nom du regroupement" v-model="form.name"></el-input>
            </el-form-item>
            <el-table style="width: 100%" ref="multipleTable" :data="form.products" stripe>
                <el-table-column prop="visuel">
                    <template slot-scope="scope">
                        <a v-if="scope.row.images.length" href="#" class="mb-3">
                            <span class="avatar" :style="{backgroundImage: 'url(\'/ic/thumbnail/'+scope.row.images[0].path+'\')'}"></span>
                        </a>
                    </template>
                </el-table-column>
                <el-table-column prop="name" label="Titre">
                </el-table-column>
                <el-table-column prop="ean13" label="Code barre">
                    <template slot-scope="scope">
                        {{ scope.row.ean13 }}
                    </template>
                </el-table-column>
                <el-table-column prop="external_ref" label="Référence fournisseur">
                    <template slot-scope="scope">
                        {{ scope.row.external_ref }}
                    </template>
                </el-table-column>
            </el-table>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-switch active-text="Syncronisé ?" v-model="sync" disabled></el-switch>
            <el-button @click="display = false">Annuler</el-button>
            <el-button type="primary" @click="action">Enregistrer</el-button>
        </span>
    </el-dialog>
</template>
<script>
import { EventBus } from '../../../event-bus';
export default {
    data() {
        return {
            display: false,
            loader: false,
            error: false,
            errorMessage: null,
            sync: true,
            form: {
                products: [],
                name: null
            }
        };
    },
    props: {
        applyToAllResult: {
            default: false
        },
        filters: {
            default: null
        },
        selected: {
            default: []
        },
        total_item: {
            default: 0
        }
    },
    computed: {
        items_selected() {
            return this.applyToAllResult
                ? this.total_item
                : this.selected.length;
        }
    },
    methods: {
        open() {
            this.form.products = Array.from(this.selected);

            this.form.products.forEach(v => {
                v.populateEditMode();
            });
            this.form.name = this.form.products[0].name;
            this.display = true;
            this.$store.dispatch('products/setLoader', false);
        },
        action() {
            let datas = { products: [], type: 'regroupment_product', name: this.form.name };
            this.form.products.forEach(v => {
                datas.products.push(v.id);
            });
            this.error = false;
            this.errorMessage = null;
            if (this.applyToAllResult) {
                datas.filters = this.filters;
            }
            datas.total_item = this.total_item
            datas.items_selected = this.items_selected
            this.$confirm('Regrouper les produits ?', 'Attention', {
                confirmButtonText: 'Oui',
                cancelButtonText: 'Annuler',
                type: 'warning'
            })
                .then(() => {
                    this.loader = true;
                    axios
                        .post('/groups', datas)
                        .then(r => {
                            this.form.products = [];
                            this.display = false;
                            EventBus.$emit('products.list.refresh');
                        })
                        .catch(() => {})
                        .then(() => {
                            this.loader = false;
                        });
                })
                .catch(() => {});
        }
    }
};
</script>
